<button class="button" (click)="showParentFilter()">
    <i class="fas fa-search"></i>
</button>
@if (parentFilter?.values?.length) {
    <div class="notificationStatusFilterWrapper">
        @for (filterValue of parentFilter.values; track filterValue) {
            <app-notification-status-renderer [parentFilterValue]="filterValue" [isFloatingFilterIcon]="true" />
        }
    </div>
}
